// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4676) return "assets/static/4676.14e68beb.chunk.js";
	if (chunkId === 7872) return "assets/static/7872.2e13c698.chunk.js";
	if (chunkId === 9335) return "assets/static/9335.89fd1b83.chunk.js";
	if (chunkId === 2272) return "assets/static/2272.aaf5b2a3.chunk.js";
	if (chunkId === 6219) return "assets/static/6219.9c0e3c8b.chunk.js";
	if (chunkId === 487) return "assets/static/487.d78e64d8.chunk.js";
	if (chunkId === 3275) return "assets/static/3275.199e1b8e.chunk.js";
	if (chunkId === 3124) return "assets/static/3124.cbc76b7d.chunk.js";
	if (chunkId === 158) return "assets/static/158.fed5df58.chunk.js";
	// return url for filenames based on template
	return undefined;
};